import axios from "axios";

function them(khachHang){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/personal/khachhang/them",khachHang);
};
function getAll(){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/personal/khachhang/getall");
};
function capNhat(khachHang){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/personal/khachhang/capnhat",khachHang);
};
function uuTien(khachHang){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/personal/khachhang/uutien",khachHang);
};
function theoDoi(khachHang){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/personal/khachhang/theodoi",khachHang);
};
function xoa(ids){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/personal/khachhang/xoa",ids);
};
function importFile(file){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/personal/khachhang/import",file);
};
function saveImportFile(listKH){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/personal/khachhang/savelist",listKH);
};
function timKiemChinhXac(key){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/personal/khachhang/timkiemchinhxac?key="+key);
};

const KhachHangPersonalService={
  timKiemChinhXac,
  saveImportFile,
  them,
  getAll,
  capNhat,
  xoa,
  importFile,
  uuTien,
  theoDoi

};
export default KhachHangPersonalService;
